export default __webpack_public_path__ + "static/media/logo.88c65f37.png";